<template>
    <v-select
        :items="dataProviders"
        item-text="provider"
        item-value="uuid"
        dense
        outlined
        v-bind="$attrs"
        v-on="$listeners"
    ></v-select>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { globalVar } from '@/helpers/globals';
import type { DataProvider } from '@/@types/data_provider';

const dpData: Array<DataProvider> = globalVar('data_providers') || [];

const dataProviders = ref<Array<DataProvider>>(dpData);
</script>
